/* eslint-disable max-statements */
import React, { useContext, useEffect, useState } from 'react';
import { context } from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { Loading } from '@catalogo/ui-americanas-desktop-product-review/src/components/atoms';
import { CommentsMsg } from '../../atoms';
import { NoComments } from '../../molecules';
import { ButtonMoreView } from './ButtonMoreView';
import { SetReview } from './SetReview';
import { ReviewsContainer, TextBox, FilteredEmpty } from './Styled';

const Reviews = (props: any) => {
  const { data, queryParam, dispatchMetrics } = useContext<any>(context);
  const { fetchMoreLoading, totalReviews, distributionReviews, comments } = data;
  const [avaliacoes, setAvaliacoes] = useState(totalReviews);
  const renderLoadingFetchMore = fetchMoreLoading && <Loading minHeight={70} />;

  const msgAfterFiltered =
    queryParam?.rating?.length != 0 ? (
      <CommentsMsg numberComments={comments} numberReviews={avaliacoes} />
    ) : (
      <TextBox className="product-review-reviews-msg-text">
        {comments} comentário{comments > 1 ? 's' : ''} pra esse produto
      </TextBox>
    );

  useEffect(() => {
    if (queryParam?.rating?.length != 0) {
      const ratingFiltered = Number(queryParam?.rating[0]);
      setAvaliacoes(distributionReviews[ratingFiltered]);
    }
  }, [queryParam]);

  if (fetchMoreLoading && !queryParam?.offset) {
    return <Loading />;
  }

  if (!totalReviews) {
    return null;
  }

  if (!comments && queryParam?.rating?.length == 0) {
    return <NoComments />;
  }

  if (!comments) {
    return <FilteredEmpty className="product-review-filtered-empty">{msgAfterFiltered}</FilteredEmpty>;
  }

  return (
    <>
      {msgAfterFiltered}
      <ReviewsContainer className="product-review-reviews-container">
        <SetReview dispatchMetrics={dispatchMetrics} />
        <ButtonMoreView />
        {fetchMoreLoading && renderLoadingFetchMore}
      </ReviewsContainer>
    </>
  );
};

export default Reviews;
export { Reviews };
